import { gql } from "@apollo/client";

export const DeactivateIoTConnection = gql`
    mutation DeactivateIoTConnection ($assetLocationId: ID!, $iotConnectionId: ID!) {
        deactivateIoTConnection (assetLocationId: $assetLocationId, iotConnectionId: $iotConnectionId) {
            success
            message
        }
    }
`;
